export enum Condition {
  AND,
  OR,
}

export namespace Condition {
  let elements = [Condition.AND, Condition.OR];
  let alias = "com.bcdfx.model.query.Condition";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
